class DateTime {
    static jupiter(timestamp) {
        const options = {
            month: "short",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        };
        const date = new Date(timestamp);
        return new Intl.DateTimeFormat("en-US", options).format(date);
    }

    static mdy(timestamp) {
        const options = {
            month: "short",
            day: "2-digit",
            year: "numeric"
        };
        const date = new Date(timestamp);
        return new Intl.DateTimeFormat("en-US", options).format(date);
    }

    static minutesAgo(offset = 1) {
        const date = new Date();
        date.setMinutes(date.getMinutes() - offset);
        return date;
    }
}

export default DateTime;
